import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ck_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const mediaUrl = (u) => (u && u.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Terjadi kesalahan. Coba lagi.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
}

export const formatIDR = (n) =>
  new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(n || 0);

export const formatDuration = (m) => {
  if (m >= 1440) return `${Math.round(m / 1440)} hari`;
  if (m >= 60 && m % 60 === 0) return `${m / 60} jam`;
  return `${m} menit`;
};

export const formatTime = (iso) =>
  iso ? new Date(iso).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short", timeZone: "Asia/Jakarta" }) : "-";

export const STATUS_LABEL = {
  awaiting_payment: "Menunggu Pembayaran",
  paid: "Menunggu Talent",
  accepted: "Diterima Talent",
  in_session: "Sesi Berjalan",
  completed: "Selesai",
  expired: "Kedaluwarsa",
  cancelled: "Dibatalkan",
  refunded: "Dana Dikembalikan",
};

export const STATUS_TONE = {
  awaiting_payment: "bg-amber-50 text-amber-700 border-amber-200",
  paid: "bg-sky-50 text-sky-700 border-sky-200",
  accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  in_session: "bg-primary/10 text-primary border-primary/30",
  completed: "bg-slate-100 text-slate-700 border-slate-200",
  expired: "bg-slate-100 text-slate-500 border-slate-200",
  cancelled: "bg-rose-50 text-rose-700 border-rose-200",
  refunded: "bg-rose-50 text-rose-700 border-rose-200",
};
